import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('work-order/index', {params});
    },
    getWo(params) {
        return Service().get('work-order/get-work-order', {params});
    },
    stats() {
        return Service().get('work-order/stats');
    },
    show(id) {
        return Service().get('work-order/show/'+id);
    },
    create(params) {
        return Service().post('work-order/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('work-order/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('work-order/delete/'+id);
    },
}